import {
  ActionIcon,
  Anchor,
  Avatar,
  Badge,
  Box,
  Card,
  Center,
  Divider,
  Group,
  ScrollArea,
  Table,
  Tabs,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { IconSearch, IconX } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import { IconCamera } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { logger } from "utils/logger";
import { EmptyState } from "core/components/emptyState/EmptyState";

import { getStyle } from "services/styleService";
import { useDispatch } from "react-redux";
import { selectStyle } from "modules/Distributions/distributionSlice";
import Moment from "react-moment";

import { PrimaryBadge } from "core/components/badge/PrimaryBadge";
import { CaptureEventType } from "../capture/CaptureThumb";
import { CaptureNoteEditor } from "../capture/CaptureNoteEditor";
import { getClientLabel, getUserAvatarColour, getUserInitials } from "utils/helper";
import classes from "./AssetInfoPanel.module.scss";
import { AppConstants, MarkupEventTypes } from "utils/constants";
import { MetaLabel } from "core/components/metaLabel/MetaLabel";
import DateDisplay from "../dateDisplay/DateDisplay";

const AssetInfoPanel = ({
  type = "style",
  selectedItem,
  selectedAnnotation,
  style,
  onItemChange,
  showComments = true,
  onAnnotationEvent, // This is now handleMarkupChange from AssetViewer
  user,
}) => {
  // const { classes } = useStyles();
  const [activeTab, setActiveTab] = useState(
    showComments ? "comments" : "info"
  );
  const [session, setSelectedSession] = useState(null);
  const [talent, setTalent] = useState([]);
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  const [selectedAsset, setSelectedAsset] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [expandedReplies, setExpandedReplies] = useState({});
  const [commentKeyword, setCommentKeyword] = useState("");

  // const dateArr = selectedItem.actionSort.split('-');
  // const y = dateArr[0];
  // const m = dateArr[1];
  // const d = dateArr[2];
  // const h = dateArr[3];
  // const min = dateArr[4];
  // const s = dateArr[5];

  // const captureDate = moment(selectedItem.actionSort, 'YYYY-MM-DD-hh-mm-ss');

  useEffect(() => {
    logger.log(selectedItem);
    const getStyleInfo = async (id) => {
      const data = await getStyle(id);

      if (data) {
        logger.log(data);
        dispatch(selectStyle(data));
      }
    };
    if (selectedItem && selectedItem.styleNumber) {
      if (
        !selectedItem.assets ||
        (selectedItem.assets.length === 0 && !hasFetched.current)
      ) {
        getStyleInfo(selectedItem.styleNumber);
        hasFetched.current = true;
      }
    }
  }, [selectedItem]);

  logger.log(selectedItem);

  const zoomImage = (data) => {
    logger.log(data);
    setSelectedAsset(data);
    setImageModalOpen(true);
  };

  const toggleReplies = (commentId) => {
    setExpandedReplies((prev) => ({
      ...prev,
      [commentId]: !prev[commentId],
    }));
  };

  logger.log(type, selectedItem, style);

  return (
    <Box className={`${classes.container} info-panel unhightable`}>
      <div style={{ width: 400, height: "calc(100% - 46px)" }}>
        {selectedItem ? (
          <Tabs
            value={activeTab}
            onChange={setActiveTab}
            defaultValue="info"
            style={{ height: "100%" }}
          >
            <Tabs.List mb="md" px="lg" pt="lg">
              <Tabs.Tab value="info">
                {type === "style" ? "Style Info" : "Capture Info"}
              </Tabs.Tab>
              {showComments && (
                <Tabs.Tab value="comments">
                  Comments{" "}
                  {selectedItem?.annotations?.length > 0
                    ? `(${selectedItem?.annotations?.length})`
                    : ""}
                </Tabs.Tab>
              )}
            </Tabs.List>

            <Tabs.Panel value="info">
              <ScrollArea style={{ height: "100%" }}>
                {type === "style" ? (
                  <Card pt="lg" style={{ background: "none" }} p={"lg"}>
                    <Title className="main-content-heading" order={5}>
                      Style Information
                    </Title>
                    <Box>
                      <Group my="md">
                        <MetaLabel>Style Number</MetaLabel>
                        <div>
                          <Text size="sm">
                            <Anchor
                              component={Link}
                              to={`/distributions/${style.styleNumber}`}
                            >
                              {style?.styleNumber}
                            </Anchor>
                          </Text>
                        </div>
                      </Group>
                      <Group my="md">
                        <MetaLabel>Department</MetaLabel>
                        <div>
                          <Text size="sm">{style.department}</Text>
                        </div>
                      </Group>

                      <Group my="md">
                        <MetaLabel>{getClientLabel(user.clientCode, 'otbDate')}</MetaLabel>
                        <div>
                          <Text size="sm">
                            {style.otbDate && style.otbDate.length ? (
                              <DateDisplay
                                value={style.otbDate}
                                parse="YYYY-MM-DD-hh-mm-ss"
                                format="DD/MM/YYYY"
                                trim
                              />
                            ) : (
                              ""
                            )}
                          </Text>
                        </div>
                      </Group>

                      {/* <Group my="md">
                      <Text size="sm" style={{ width: "30%" }} weight="500">
                        Distribution Date
                      </Text>
                      <div>
                        <Text size="sm">
                          {style.distributionDate &&
                          style.distributionDate.length ? (
                            <Moment
                              date={style.distributionDate}
                              parse="YYYY-MM-DD-hh-mm-ss"
                              format="DD/MM/YYYY"
                              trim
                            />
                          ) : (
                            ""
                          )}
                        </Text>
                      </div>
                    </Group> */}
                    </Box>
                    <Divider />
                    <Box mt={"xl"}>
                      <Group mb="lg">
                        <Title className="main-content-heading" order={6}>
                          Tags
                        </Title>
                        {selectedItem?.tags && selectedItem.tags.length ? (
                          <PrimaryBadge>
                            {selectedItem?.tags?.split(",").length}
                          </PrimaryBadge>
                        ) : null}
                      </Group>
                      <Group gap={"xs"} sx={{ justifyContent: "center" }}>
                        {selectedItem?.tags &&
                        selectedItem.tags.length ? null : (
                          <Text size="sm" c={"dimmed"}>
                            No tags available
                          </Text>
                        )}
                        {selectedItem &&
                          selectedItem.tags &&
                          selectedItem.tags.length &&
                          selectedItem.tags.split(",").map((val, idx) => (
                            <Badge
                              key={idx}
                              color="gray"
                              variant="default"
                              gradient={{
                                from: "#ed6ea0",
                                to: "#ec8c69",
                                deg: 35,
                              }}
                            >
                              {val}
                            </Badge>
                          ))}

                        {/* <Badge variant="gradient" gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }}>Winter</Badge> */}
                      </Group>

                      {!selectedItem ||
                      (selectedItem && selectedItem.assets?.length === 0) ? (
                        <EmptyState
                          caption="There are no assets"
                          style={{ height: 200 }}
                        />
                      ) : null}
                      {/* <TalentList data={[{avatar:selectedItem.filePath,name:'Test User'}]}/> */}
                      <Divider my={"xl"} />
                      {/* add a note editor component that captures the user and timestamp and note */}
                      <Title className="main-content-heading" order={6} mb="sm">
                        Approval Notes
                      </Title>
                      <Text mb="lg" size="sm" c={"dimmed"}>
                        Enter any notes you have for this asset. These notes
                        will be sent to the retouching team.
                      </Text>
                      <CaptureNoteEditor
                        notes={selectedItem?.clientNotes || ""}
                        onNotesChange={(newNotes) => {
                          // Handle notes change - you can implement the actual save logic here
                          console.log("Notes updated:", newNotes);
                          // add the new notes to the selectedItem
                          onItemChange(
                            CaptureEventType.NOTES_CHANGE,
                            { data: newNotes },
                            [selectedItem]
                          );
                        }}
                      />
                    </Box>
                  </Card>
                ) : (
                  <Card pt="lg" style={{ background: "none" }} p={"lg"}>
                    <Title className="main-content-heading" order={5}>
                      Capture Information
                    </Title>
                    <Box>
                      <Group my="md">
                        <MetaLabel>Style Number</MetaLabel>
                        <div>
                          <Text size="sm">{style?.styleNumber}</Text>
                        </div>
                      </Group>

                      <Group my="md">
                        <MetaLabel>Session</MetaLabel>
                        <div>
                          <Text size="sm">{style?.sessionName}</Text>
                        </div>
                      </Group>

                      <Group my="md">
                        <MetaLabel>Capture</MetaLabel>
                        <div>
                          <Text size="sm">{selectedItem.name}</Text>
                        </div>
                      </Group>
                      <Group my="md">
                        <MetaLabel>Created</MetaLabel>
                        <div>
                          <Text size="sm">
                            {selectedItem.actionSort ? (
                              <Moment
                                date={selectedItem.actionSort}
                                parse="YYYY-MM-DD-HH-mm-ss-SSS"
                                format="DD/MM/YYYY HH:mm:ss"
                                trim
                              />
                            ) : (
                              "-"
                            )}
                          </Text>
                        </div>
                      </Group>
                      <Divider />

                      <Title className="main-content-heading" mt="xl" order={5}>
                      Task Information
                    </Title>
                      <Group my="md">
                        <MetaLabel>Description</MetaLabel>
                        <div>
                          <Text size="sm">{style?.description}</Text>
                        </div>
                      </Group>
                      <Group my="md">
                        <MetaLabel>Season</MetaLabel>
                        <div>
                          <Text size="sm">{style?.seasonCode}</Text>
                        </div>
                      </Group>
                      <Group my="md">
                        <MetaLabel>Deadline</MetaLabel>
                        <div>
                          <Text size="sm">
                          <Moment
                                date={style?.deadline}
                                parse="YYYY-MM-DD-HH-mm-ss-SSS"
                                format="DD/MM/YYYY"
                                trim
                              />
                              </Text>
                        </div>
                      </Group>
                      
                      {/* <Group my="md">
                      <Text size="sm" style={{ width: "30%" }} weight="500">
                        Distribution Date
                      </Text>
                      <div>
                        <Text size="sm">
                          {style.distributionDate &&
                          style.distributionDate.length ? (
                            <Moment
                              date={style.distributionDate}
                              parse="YYYY-MM-DD-hh-mm-ss"
                              format="DD/MM/YYYY"
                              trim
                            />
                          ) : (
                            ""
                          )}
                        </Text>
                      </div>
                    </Group> */}
                    </Box>
                  </Card>
                )}
              </ScrollArea>
            </Tabs.Panel>

            {showComments && (
              <Tabs.Panel value="comments" style={{ height: "100%" }}>
                {/* Header */}
                <Box p="lg">
                  <Group justify="space-between" mb="md">
                    <Title className="main-content-heading" order={5}>
                      Comments
                    </Title>
                    {/* <Text size="sm" c="dimmed" style={{ cursor: "pointer" }}>
                          100% ▾
                        </Text> */}
                  </Group>
                  <Group gap="xs">
                    <TextInput
                      placeholder="Search comments..."
                      leftSection={<IconSearch size={AppConstants.ICON_SIZE} />}
                      rightSection={
                        commentKeyword ? (
                          <ActionIcon
                            variant="subtle"
                            size="sm"
                            onClick={() => setCommentKeyword("")}
                            title="Clear search"
                          >
                            <IconX size={14} />
                          </ActionIcon>
                        ) : null
                      }
                      style={{ flex: 1 }}
                      value={commentKeyword}
                      onChange={(e) => setCommentKeyword(e.target.value)}
                    />
                    {/* <ActionIcon variant="subtle" size="lg">
                      <IconFilter size={AppConstants.ICON_SIZE} />
                    </ActionIcon>
                    <ActionIcon variant="subtle" size="lg">
                      <IconDots size={AppConstants.ICON_SIZE} />
                    </ActionIcon> */}
                  </Group>
                </Box>

                {/* Comments List */}
                <ScrollArea style={{ height: `calc(100vh - 270px)` }} px="lg">
                  {selectedItem?.annotations?.length === 0 ? (
                    <Group>
                      <EmptyState
                        caption="No comments"
                        style={{ height: 200 }}
                      />
                    </Group>
                  ) : (
                    <Box>
                      {(() => {
                        // Filter annotations based on keyword
                        let filteredAnnotations =
                          selectedItem?.annotations || [];

                        if (commentKeyword.trim()) {
                          const keywordLower = commentKeyword.toLowerCase();
                          filteredAnnotations = filteredAnnotations.filter(
                            (annotation) => {
                              var markup = annotation.payload.markup
                                ? annotation.payload.markup
                                : annotation.payload.payload;
                              var bodies = markup?.bodies || [];

                              // Check if username matches
                              const userMatch = annotation.user
                                ?.toLowerCase()
                                .includes(keywordLower);

                              // Check if any comment body matches
                              const bodyMatch = bodies.some((bodyItem) =>
                                bodyItem?.value
                                  ?.toLowerCase()
                                  .includes(keywordLower)
                              );

                              return userMatch || bodyMatch;
                            }
                          );
                        }

                        // Render filtered comments
                        if (
                          filteredAnnotations &&
                          filteredAnnotations.length > 0
                        ) {
                          return filteredAnnotations.map((annotation, idx) => {
                            var markup = annotation.payload.markup
                              ? annotation.payload.markup
                              : annotation.payload.payload;
                            var bodies = markup?.bodies || [];

                            // If there's a keyword, filter bodies too
                            let filteredBodies = bodies;
                            if (commentKeyword.trim()) {
                              const keywordLower = commentKeyword.toLowerCase();
                              filteredBodies = bodies.filter(
                                (bodyItem) =>
                                  bodyItem?.value
                                    ?.toLowerCase()
                                    .includes(keywordLower) ||
                                  annotation.user
                                    ?.toLowerCase()
                                    .includes(keywordLower)
                              );
                            }

                            // Only show this annotation if it has matching bodies
                            if (filteredBodies.length === 0) {
                              return null;
                            }

                            return (
                              <Box key={idx}>
                                {filteredBodies.map((bodyItem, i) => {
                                  const created = markup?.target?.created;
                                  const creatorId =
                                    markup?.target?.creator?.id ||
                                    annotation?.user ||
                                    "U";
                                  const initials = getUserInitials(
                                    annotation.user.split(" ")[0],
                                    annotation.user.split(" ")[1]
                                  );
                                  return (
                                    <>
                                      <Box
                                        key={`${idx}-${i}`}
                                        className={`${
                                          classes.commentContainer
                                        } ${
                                          selectedAnnotation?.payload?.markup
                                            ?.id ===
                                          annotation?.payload?.markup?.id
                                            ? classes.selected
                                            : ""
                                        }`}
                                        onClick={() =>
                                          onAnnotationEvent &&
                                          onAnnotationEvent(
                                            MarkupEventTypes.SELECT_MARKUP,
                                            {
                                              image: selectedItem,
                                              payload:
                                                annotation.payload.markup,
                                            }
                                          )
                                        }
                                      >
                                        <Avatar
                                          size="sm"
                                          color={getUserAvatarColour(initials)}
                                        >
                                          {initials}
                                        </Avatar>
                                        <Group align="center" my="xs">
                                          <Group align="center" gap="xs">
                                            {/* <Avatar
                                            size="sm"
                                            color={getUserAvatarColour(
                                              initials
                                            )}
                                          >
                                            {initials}
                                          </Avatar> */}
                                            <Text size="sm" fw={800}>
                                              {annotation.user}
                                            </Text>
                                          </Group>
                                          {created ? (
                                            <Text size="sm" c="dimmed">
                                              <Moment
                                                date={created}
                                                format=""
                                                fromNow
                                              />
                                            </Text>
                                          ) : null}
                                        </Group>
                                        <Text size="sm" mt={8}>
                                          {bodyItem?.value}
                                        </Text>
                                      </Box>
                                      <Divider my="sm" />
                                    </>
                                  );
                                })}
                              </Box>
                            );
                          });
                        } else if (
                          selectedItem?.annotations &&
                          selectedItem?.annotations?.length > 0
                        ) {
                          // No results from filter
                          return (
                            <EmptyState
                              caption="No comments match your search"
                              style={{ height: 200 }}
                            />
                          );
                        } else {
                          // No comments at all
                          return null;
                        }
                      })()}
                    </Box>
                  )}
                </ScrollArea>
              </Tabs.Panel>
            )}
          </Tabs>
        ) : (
          <Center sx={{ height: "100%", minHeight: 400 }}>
            <div style={{ textAlign: "center" }}>
              <IconCamera size={48} stroke={1} />
              <Title color={"dimmed"} order={3}>
                Select an Image
              </Title>
            </div>
          </Center>
        )}
      </div>
    </Box>
  );
};

export default AssetInfoPanel;

export function TalentList({ data }) {
  const rows = data.map((item) => (
    <tr key={item.name}>
      <td>
        <Group spacing="sm">
          <Avatar size={40} src={item.avatar} radius={40} />
          <div>
            <Text size="sm" weight={500}>
              {item.name}
            </Text>
            <Text size="xs" color="dimmed">
              {item.email}
            </Text>
          </div>
        </Group>
      </td>

      {/* <td>
          
        </td>
        <td>{Math.floor(Math.random() * 6 + 5)} days ago</td>
        <td>
          {Math.random() > 0.5 ? (
            <Badge fullWidth>Active</Badge>
          ) : (
            <Badge color="gray" fullWidth>
              Disabled
            </Badge>
          )}
        </td> */}
    </tr>
  ));

  return (
    <Table verticalSpacing="sm">
      {/* <thead>
            <tr>
              <th>Employee</th>
              <th>Role</th>
              <th>Last active</th>
              <th>Status</th>
            </tr>
          </thead> */}
      <tbody>{rows}</tbody>
    </Table>
  );
}
